export const getTopUniqueGoals = (goals = []) => {
  if (!goals.length) return [];
  const unique = [];
  const cats = new Set();
  
  goals.forEach(g => {
    if (unique.length < 3 && g.category && !cats.has(g.category)) {
      unique.push(g);
      cats.add(g.category);
    }
  });
  return unique;
};